import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["0%\n{ opacity: 0; }\n100%\n{ opacity: 1; }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css, keyframes } from '@emotion/react';
var spinner = keyframes(_templateObject());
var spinnerStyle = /*#__PURE__*/css({
  g: {
    animation: "".concat(spinner, " 1s infinite")
  },
  'g:nth-of-type(1)': {
    animationDelay: '-0.9166666666666666s'
  },
  'g:nth-of-type(2)': {
    animationDelay: '-0.8333333333333334s'
  },
  'g:nth-of-type(3)': {
    animationDelay: ' -0.75s'
  },
  'g:nth-of-type(4)': {
    animationDelay: '-0.6666666666666666s'
  },
  'g:nth-of-type(5)': {
    animationDelay: '-0.5833333333333334s'
  },
  'g:nth-of-type(6)': {
    animationDelay: '-0.5s'
  },
  'g:nth-of-type(7)': {
    animationDelay: '-0.4166666666666667s'
  },
  'g:nth-of-type(8)': {
    animationDelay: '-0.3333333333333333s'
  },
  'g:nth-of-type(9)': {
    animationDelay: '-0.25s'
  },
  'g:nth-of-type(10)': {
    animationDelay: '-0.16666666666666666s'
  },
  'g:nth-of-type(11)': {
    animationDelay: '-0.08333333333333333s'
  },
  'g:nth-of-type(12)': {
    animationDelay: '0s'
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:spinnerStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9CdXR0b24vc3Bpbm5lclN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9xQiIsImZpbGUiOiIuLi8uLi9zcmMvQnV0dG9uL3NwaW5uZXJTdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywga2V5ZnJhbWVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBzcGlubmVyID0ga2V5ZnJhbWVzYDAlXG57IG9wYWNpdHk6IDA7IH1cbjEwMCVcbnsgb3BhY2l0eTogMTsgfWA7XG5cbmNvbnN0IHNwaW5uZXJTdHlsZSA9IGNzcyh7XG4gIGc6IHtcbiAgICBhbmltYXRpb246IGAke3NwaW5uZXJ9IDFzIGluZmluaXRlYCxcbiAgfSxcblxuICAnZzpudGgtb2YtdHlwZSgxKSc6IHtcbiAgICBhbmltYXRpb25EZWxheTogJy0wLjkxNjY2NjY2NjY2NjY2NjZzJyxcbiAgfSxcbiAgJ2c6bnRoLW9mLXR5cGUoMiknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICctMC44MzMzMzMzMzMzMzMzMzM0cycsXG4gIH0sXG4gICdnOm50aC1vZi10eXBlKDMpJzoge1xuICAgIGFuaW1hdGlvbkRlbGF5OiAnIC0wLjc1cycsXG4gIH0sXG4gICdnOm50aC1vZi10eXBlKDQpJzoge1xuICAgIGFuaW1hdGlvbkRlbGF5OiAnLTAuNjY2NjY2NjY2NjY2NjY2NnMnLFxuICB9LFxuICAnZzpudGgtb2YtdHlwZSg1KSc6IHtcbiAgICBhbmltYXRpb25EZWxheTogJy0wLjU4MzMzMzMzMzMzMzMzMzRzJyxcbiAgfSxcbiAgJ2c6bnRoLW9mLXR5cGUoNiknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICctMC41cycsXG4gIH0sXG4gICdnOm50aC1vZi10eXBlKDcpJzoge1xuICAgIGFuaW1hdGlvbkRlbGF5OiAnLTAuNDE2NjY2NjY2NjY2NjY2N3MnLFxuICB9LFxuICAnZzpudGgtb2YtdHlwZSg4KSc6IHtcbiAgICBhbmltYXRpb25EZWxheTogJy0wLjMzMzMzMzMzMzMzMzMzMzNzJyxcbiAgfSxcbiAgJ2c6bnRoLW9mLXR5cGUoOSknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICctMC4yNXMnLFxuICB9LFxuICAnZzpudGgtb2YtdHlwZSgxMCknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICctMC4xNjY2NjY2NjY2NjY2NjY2NnMnLFxuICB9LFxuICAnZzpudGgtb2YtdHlwZSgxMSknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICctMC4wODMzMzMzMzMzMzMzMzMzM3MnLFxuICB9LFxuICAnZzpudGgtb2YtdHlwZSgxMiknOiB7XG4gICAgYW5pbWF0aW9uRGVsYXk6ICcwcycsXG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgc3Bpbm5lclN0eWxlO1xuIl19 */");
export default spinnerStyle;